interface IReturnProductInstallmentInfo {
  prepaymentAmount: number;
  biannualPaymentAmount: number;
  totalPaymentPeriod: number;
}

// TODO : 선수금, 반기별 납부액 관련 로직을 FE 에서 구현하는 것이 맞는지에 대한 논의 필요 https://gint-team.atlassian.net/browse/PVM-2760
export const getProductInstallmentInfo = (productPrice: number): IReturnProductInstallmentInfo => {
  const PREPAYMENT_RATE = 0.3;
  const YEARLY_INTEREST_RATE = 0.04;
  const PAYMENTS_PER_YEAR = 1;
  // const TOTAL_PAYMENT_PERIOD = checkPriceUnit(productPrice).isOver100Million ? 3 : 2;
  const TOTAL_PAYMENT_PERIOD = 5;

  const prepaymentAmount = productPrice * PREPAYMENT_RATE;
  const remainingAmount = productPrice - prepaymentAmount;

  const totalInterestAmount = remainingAmount * YEARLY_INTEREST_RATE * TOTAL_PAYMENT_PERIOD;

  const biannualPaymentAmount = (remainingAmount + totalInterestAmount) / (PAYMENTS_PER_YEAR * TOTAL_PAYMENT_PERIOD);

  return {
    prepaymentAmount,
    biannualPaymentAmount,
    totalPaymentPeriod: TOTAL_PAYMENT_PERIOD,
  };
};
